import { BeerState } from '../types';

/**
 * Base Action interface
 * Following the Command pattern for better extensibility
 */
export interface Action<T = any> {
  type: string;
  payload?: T;
  execute(state: BeerState): BeerState;
}

/**
 * Base Action class that all specific actions can extend
 * Provides common functionality for all actions
 */
export abstract class BaseAction<T = any> implements Action<T> {
  abstract type: string;
  payload?: T;
  
  constructor(payload?: T) {
    this.payload = payload;
  }
  
  abstract execute(state: BeerState): BeerState;
}
